import gsap from "gsap";

export const mixinAnimate = {
  methods: {
    // 页面或者组件初始动画
    initComponent(
      GASP,
      ELEMENT,
      FORM_OPACITY = 0,
      TO_OPACITY = 1,
      DIRECTION = "x",
      FROM_DISTANCE = 400,
      TO_DISTANCE,
      DURATION = 0.8,
      EASE = "power2.out"
    ) {
      if (GASP) GASP.kill();
      GASP = gsap.timeline();
      GASP.fromTo(
        ELEMENT,
        {
          opacity: FORM_OPACITY,
          [DIRECTION]: FROM_DISTANCE,
        },
        {
          opacity: TO_OPACITY,
          [DIRECTION]: TO_DISTANCE,
          duration: DURATION,
          ease: EASE,
        }
      );
    },
    // 处理鼠标移入或者移出事件
    mouseEnterLeave(
      GASP,
      ELEMENT,
      SCALE = 1.5,
      DURATION = 0.8,
      EASE = '"power2.out"'
    ) {
      if (GASP) GASP.kill();
      GASP = gsap.timeline();
      GASP.to(ELEMENT, {
        duration: DURATION,
        scale: SCALE,
        ease: EASE,
      });
    },

    // 展开动画
    expanded(
      GASP,
      ELEMENT,
      INIT_DISTANCE = "0",
      MAX_DISTANCE = "auto",
      DURATION = 0.8,
      EASE = "elastic.out(1, 0.5)",
      DIRECTION = "height"
    ) {
      if (GASP) GASP.kill();
      GASP = gsap.timeline();
      GASP.fromTo(
        ELEMENT,
        { [DIRECTION]: INIT_DISTANCE, opacity: 0 },
        {
          opacity: 1,
          [DIRECTION]: MAX_DISTANCE,
          duration: DURATION,
          ease: EASE,
        }
      );
    },

    // 收起动画
    collapse(
      GASP,
      ELEMENT,
      DISTANCE = "0px",
      DURATION = 0.5,
      EASE = "back.in(1.2)",
      DIRECTION = "height"
    ) {
      if (GASP) GASP.kill();
      GASP = gsap.timeline();
      GASP.to(ELEMENT, {
        [DIRECTION]: DISTANCE,
        duration: DURATION,
        ease: EASE,
      });
    },

    // 清除动画
    clearGasp(GASP) {
      if (GASP) GASP.kill();
    },
  },
};
